<div class="card card-box rounded border-0 p-2">
    <div class="py-0">
        <h3 class="text-center">Dictionnaires - Note de frais</h3>
    </div>
    <hr class="border-2">
    <!-- <app-no-data *ngIf="frais && frais.length === 0" [title]="'Aucun compte charge soc./fisc. trouvé'"></app-no-data> -->
    <!-- <div *ngIf="frais && frais.length > 0"> -->
        <span class="badge badge-primary my-2 f-14 width">Listes des notes de frais </span>
        <div class="table-responsive m-0">
            <table datatable [dtOptions]="dtOptions" class="table table-striped m-0">
                <thead class="thead-light">
                <tr>
                    <th>Code</th>
                    <th>Libellé</th>
                    <th>Code comptable</th>
                    <th>État</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of frais">
                        <!-- <td>
                            <span>
                                {{item?.code}}
                            </span>
                        </td>
                        <td>
                            <span>
                                {{item?.libelle}}
                            </span>
                        </td>
                        <td>
                            <span class="badge badge-dark">
                                {{item?.type}}
                            </span>
                        </td>
                        <td>
                            <button type="button" (click)="show(item)" class="btn btn-icon btn-secondary" ngbTooltip="Détails">
                                <i class="fas fa-eye"></i>
                            </button>
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </div>
    <!-- </div> -->
</div>